/*
 * ATTENTION: An "eval-source-map" devtool has been used.
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file with attached SourceMaps in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/homepage/image-with-categories.js":
/*!****************************************************************!*\
  !*** ./zrc/scripts/sections/homepage/image-with-categories.js ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/modules/navigation/navigation.js\");\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/core/core.js\");\n/* eslint-disable @babel/no-unused-expressions */\n\nclass ImageWithCategories extends HTMLElement {\n  constructor() {\n    super();\n    this.$section = this;\n    this.$swiper = this.querySelector('.swiper');\n    this.slidesCount = Number(this.$swiper.dataset.slidesCount);\n    this.hasNavigation = this.$swiper.dataset.hasNavigation === 'true';\n    this.swiperSettings = {\n      modules: [swiper__WEBPACK_IMPORTED_MODULE_0__.default],\n      slidesPerView: 'auto',\n      speed: 500,\n      loop: false,\n      longSwipesRatio: 0.1,\n      resistanceRatio: 0,\n      simulateTouch: this.slidesCount > 1,\n      allowTouchMove: this.slidesCount > 1,\n      navigation: {\n        nextEl: this.$swiper.parentElement.querySelector('.swiper-button.next'),\n        prevEl: this.$swiper.parentElement.querySelector('.swiper-button.prev')\n      }\n    };\n    this.init();\n\n    // Add the on block select event listener\n    document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));\n  }\n  init() {\n    this.initSwiper();\n  }\n  onBlockSelect(event) {\n    const currentSlide = Number(event.srcElement.dataset.swiperSlideIndex);\n    this.swiper.slideTo(currentSlide);\n  }\n  initSwiper() {\n    // Agrega la configuración correspondiente cuando hay paginación/navegación\n    this.hasNavigation && this.#setSwiperNavigation();\n    this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_1__.default(this.$swiper, this.swiperSettings);\n  }\n  #setSwiperNavigation() {\n    // Si existe la navegación, se agrega a las opciones del Swiper\n    const $nextButton = this.querySelector('.swiper-button.next');\n    const $prevButton = this.querySelector('.swiper-button.prev');\n    this.swiperSettings.navigation = {\n      nextEl: $nextButton,\n      prevEl: $prevButton\n    };\n  }\n}\nif (!window.customElements.get('image-with-categories')) {\n  window.customElements.define('image-with-categories', ImageWithCategories);\n}//# sourceURL=[module]\n//# sourceMappingURL=data:application/json;charset=utf-8;base64,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\n//# sourceURL=webpack-internal:///./zrc/scripts/sections/homepage/image-with-categories.js\n");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"image-with-categories": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/homepage/image-with-categories.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;